"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pieve-santo-stefano": {
    "1ff8e86e": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "baldignano": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "babae368": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "cerbaiolo": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "88224d71": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "cercetole": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "52e7ac53": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "cirignone": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4849449d": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "mogginano": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa8ed89b": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "sintigliano": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "ca07852b": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "skipSearch": false
    }],
    "tizzano": [{
      "hkey": "0fe1a133",
      "slug": "pieve-santo-stefano",
      "name": "Pieve Santo Stefano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;